import NotificationContactsProvider from "./NotificationContactsProvider"
import NotificationDetails from "./NotificationDetails"

interface PoolNotificationsProps {
  poolId: number
}

function PoolNotifications({ poolId }: PoolNotificationsProps) {
  return (
    <NotificationContactsProvider poolId={poolId}>
      <NotificationDetails />
    </NotificationContactsProvider>
  )
}
export default PoolNotifications
